// noinspection JSUnresolvedReference

(function(app) {
    const elements = {
        cartQtyInputEl: null,
        qtyDecreaseBtnEl: null,
        qtyIncreaseBtnEl: null,
        fullPriceEl: null,
        unitPriceEl: null,
        priceWrapperEl: null
    };

    app.CartIntegration = {
        priority: -100,

        init() {
            elements.cartQtyInputEl = document.querySelector('.wdatca-quantity-wrapper input[name="quantity"]');
            elements.qtyDecreaseBtnEl = document.querySelector('.wdatca-quantity-wrapper .quantity-decrease');
            elements.qtyIncreaseBtnEl = document.querySelector('.wdatca-quantity-wrapper .quantity-increase');
            elements.fullPriceEl = document.querySelector('.wdatca-price-wrapper .wdatca-current-price');
            elements.unitPriceEl = document.querySelector('.wdatca-price-wrapper .wdatca-current-price-per-unit');
            elements.priceWrapperEl = document.querySelector('.wdatca-price-wrapper');
            elements.legacyQtyInputEl = document.querySelector('.woocommerce-variation-add-to-cart input.qty');

            // Validate required elements
            if (!app.Utils.validateElements('cart elements', {
                'quantity input': '.wdatca-quantity-wrapper input[name="quantity"]',
                'quantity decrease button': '.wdatca-quantity-wrapper .quantity-decrease',
                'quantity increase button': '.wdatca-quantity-wrapper .quantity-increase',
                'full price element': '.wdatca-price-wrapper .wdatca-current-price',
                'unit price element': '.wdatca-price-wrapper .wdatca-current-price-per-unit',
                'price wrapper': '.wdatca-price-wrapper'
            })) {
                return;
            }

            // Initialize with store state
            this.setupQuantityHandlers();
            this.setupPriceLoadingHandlers();

            // Set initial quantity
            const initialQty = parseInt(elements.cartQtyInputEl.value) || 1;
            app.Store.setState('quantity', initialQty);

            // Subscribe to quantity changes
            app.Store.subscribe('quantity', (quantity) => {
                this.updateQuantityDisplay(quantity);
                this.updateLegacyQuantityInput(quantity);
                this.calcPrice();
            });

            // Subscribe to attribute changes
            app.Store.subscribe('attributes', () => {
                this.calcPrice();
            });

            // Subscribe to price changes
            app.Store.subscribe('price', (price) => {
                this.updatePriceDisplay(price);
            });

            app.Store.subscribe('discount', (discount) => {
                if (!discount.triggerCartChange) {
                    return;
                }

                app.Store.setState('quantity', discount.quantity);
            });

            app.Store.subscribe('text', () => {
                this.calcPrice();
            });

            app.Store.subscribe('text-width', () => {
                this.calcPrice();
            });

            app.Store.subscribe('text-height', () => {
                this.calcPrice();
            });

            app.Store.subscribe('text-baseheight', () => {
                this.calcPrice();
            });

            app.Store.subscribe('size', () => {
                this.calcPrice();
            });

            app.Store.subscribe('layerColors', () => {
                this.calcPrice();
			});

			app.Store.subscribe('isSet', () => {
				this.calcPrice();
			});

            app.Store.subscribe('initialized', () => {
                this.calcPrice();
            });
        },

        calcPrice() {
            if (app.Store.getState('initialized')) {
                app.Utils.debouncedCalculatePriceAjax();
            }
        },

        updateQuantityDisplay(quantity) {
            if (elements.cartQtyInputEl) {
                elements.cartQtyInputEl.value = quantity;
            }
        },

        updateLegacyQuantityInput(quantity){
            if (elements.legacyQtyInputEl) {
                elements.legacyQtyInputEl.value = quantity;
            }
        },

        updatePriceDisplay(price) {
            if (!price) {
                return;
            }

            if (elements.fullPriceEl) {
                elements.fullPriceEl.textContent = price.fullPriceFormatted;
            }

            if (elements.unitPriceEl) {
                elements.unitPriceEl.textContent = price.unitPriceFormatted;
            }
        },

        setupPriceLoadingHandlers() {
            app.Store.subscribe('isCalculatingPrice', (isCalculating) => {
                if (isCalculating && !elements.priceWrapperEl.classList.contains('is-loading')) {
                    elements.priceWrapperEl.classList.add('is-loading');
                    elements.fullPriceEl.textContent = 'Indlæser...';
                    elements.unitPriceEl.textContent = 'Indlæser...';
                } else if (!isCalculating && elements.priceWrapperEl.classList.contains('is-loading')) {
                    elements.priceWrapperEl.classList.remove('is-loading');
                }
            });
        },

        setupQuantityHandlers() {
            // Handle manual input
            elements.cartQtyInputEl.addEventListener('change', () => {
                let quantity = parseInt(elements.cartQtyInputEl.value);
                if (isNaN(quantity) || quantity < 1) {
                    quantity = 1;
                }
                app.Store.setState('quantity', quantity);
            });

            // Handle decrease button
            elements.qtyDecreaseBtnEl.addEventListener('click', () => {
                const currentQty = this.getQuantity();
                if (currentQty > 1) {
                    app.Store.setState('quantity', currentQty - 1);
                }
            });

            // Handle increase button
            elements.qtyIncreaseBtnEl.addEventListener('click', () => {
                const currentQty = this.getQuantity();
                app.Store.setState('quantity', currentQty + 1);
            });
        },

        getQuantity() {
            return app.Store.getState('quantity') || 1;
        },

        /**
         * Get the quantity data for cart export
         * @returns {object} The quantity data for the cart
         */
        getCartData() {
            return {
                quantity: this.getQuantity(),
                price: app.Store.getState('price')
            };
        },

        /**
         * Get the price data for price calculation
         * @returns {object} The price data for the price
         */
        getPriceData() {
            return {
                quantity: this.getQuantity()
            };
        },

    };
})(window.app = window.app || {});